/*
 * Copyright (c) Worldline 2022.
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-wl-iban-form',
    templateUrl: './wl-iban-form.component.html'
})
export class WlIbanFormComponent implements OnInit {

    constructor() {
    }

    @Input()
    evidenceId: any;

    @Input()
    form: any;

    @Input()
    formController: any;

    @Input()
    partId: any;

    @Input()
    type: any;

    resultData = {}
    editMode = true;
    errorMsg: any;

    private ibanCode = 'IBAN_CODE';
    private bic = 'IBAN_BIC';

    ngOnInit(): void {
        const that = this;

        console.debug(
            'I am iban ctrl for ev : ' + this.evidenceId + '/' + this.partId
        );

        this.resultData[this.ibanCode] = '';
        this.resultData[this.bic] = '';

        this.formController.getJson = function () {
            // IBAN code is OK
            if (that.isIbanOk()) {
                return that.resultData;
            } else {
                that.setFormDirty();
                return null;
            }
        };

        this.formController.enableEdition = function () {
            that.editMode = true;
        };

        this.formController.disableEdition = function () {
            that.editMode = false;
        };

        this.formController.setData = function (data) {
            that.resultData[that.ibanCode] = data[that.ibanCode];
            that.resultData[that.bic] = data[that.bic];
            that.editMode = false;
        };

        this.formController.manageError = function (error) {
            that.errorMsg = error;
        };
    }

    /**
     * Check if the whole IBAN is correct
     * @return {boolean}
     */
    private isIbanOk() {
        var digitsIban = '',
            asciiValue = 0;

        // reset validity
        this.form.iban.$setValidity('invalid', true);

        if (!this.form.$valid) {
            return false;
        }

        var reversedIban = this.resultData[this.ibanCode].substr(4) +
            this.resultData[this.ibanCode].substr(0, 4);
        reversedIban = reversedIban.toUpperCase();
        console.debug('IBAN : Reversed IBAN is "' + reversedIban + '"');

        for (var i = 0; i < reversedIban.length; i++) {
            asciiValue = reversedIban.charCodeAt(i);
            // If letter then convert to digit
            if (asciiValue >= 65) {
                // -65 to get alphabetical order then +10 to get valid digit
                digitsIban += asciiValue - 55;
            } else {
                digitsIban += reversedIban[i];
            }
        }

        console.debug(
            'IBAN : Integer version of IBAN is "' + digitsIban + '"'
        );

        var res = this.bigModulo(digitsIban, 97) === 1;
        this.form.iban.$setValidity('invalid', res);

        return res;
    }

    /**
     * Perform a modulo of a big number.
     * @param {string} divident
     * @param {number} divisor
     * @return {number}
     */
    private bigModulo(divident, divisor) {
        var part = '',
            partLength = 10;

        while (divident.length > partLength) {
            part = divident.substr(0, partLength);
            divident = (part as any % divisor) + divident.substr(partLength);
        }

        return divident % divisor;
    }

    private setFormDirty() {
        this.form.$setDirty();
        this.form.$error.forEach(field => {
            field.forEach(errorField => {
                if (errorField !== undefined) {
                    errorField.$setViewValue(errorField.$viewValue);
                }
            })
        })
    }

}